/**
 * Find any existing user info that may exist on the window
 * @param {*} windowObj
 */
export const getUserSysId = windowObj => {
	// we should only get this default user in a dev scenario or there is a bug with UXF
	const userSysId = 'defaultSeismicUser';

	if (!windowObj) {
		setUserSysId(userSysId);
		return userSysId;
	}

	// Check for tempUserSysId
	if (windowObj.nowUiFramework && windowObj.nowUiFramework.tempUserSysId)
		return windowObj.nowUiFramework.tempUserSysId;

	// Jelly && UXF based pages
	if (windowObj.NOW && windowObj.NOW.user && windowObj.NOW.user.userID)
		return windowObj.NOW.user.userID;

	// Fall back on window token
	if (windowObj.g_ck) return windowObj.g_ck;

	//Is there a better way I'm missing?
	setUserSysId(userSysId);
	return userSysId;
};

export const setUserSysId = userSysId => {
	globalThis.nowUiFramework = globalThis.nowUiFramework || {};
	globalThis.nowUiFramework.tempUserSysId = userSysId;
};
